export const canUseDOM = Boolean(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
export const IS_IOS = canUseDOM && /iphone|ipad|ipod/i.test(window.navigator.userAgent);
export function isUyghur(text) {
    const arabicRegex = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/;
    const uyghurSpecificRegex = /[\u06AD\u0686\u06C7\u06CB\u06D0]/;
    return arabicRegex.test(text) && uyghurSpecificRegex.test(text);
}
